/**
 * §19.1 — Açık / koyu / sistem. Seçim localStorage'da; kayıt yoksa cihazın ayarı izleniyor.
 *
 * `index.html`deki satır içi betik aynı anahtarı okuyup ilk boyamadan önce `data-theme`i yazıyor:
 * anahtarın adı ve "kayıt yok = sistem" kuralı ikisinde aynı kalmalı.
 */

export type Theme = 'light' | 'dark';
export type TemaTercihi = Theme | 'system';

const STORAGE_KEY = 'amzjp-theme';
const OLAY = 'amzjp-tema-degisti';

/** Gizli sekmede localStorage yazılamayabilir; seçim bu sayfada yine geçerli kalsın. */
let sayfaTercihi: TemaTercihi | null = null;

export function getStoredTheme(): Theme | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === 'light' || value === 'dark' ? value : null;
  } catch {
    return null;
  }
}

export function getSystemTheme(): Theme {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function temaTercihi(): TemaTercihi {
  return sayfaTercihi ?? getStoredTheme() ?? 'system';
}

function uygula(): void {
  const tercih = temaTercihi();
  document.documentElement.setAttribute(
    'data-theme',
    tercih === 'system' ? getSystemTheme() : tercih,
  );
  window.dispatchEvent(new Event(OLAY));
}

export function temaTercihiniAyarla(tercih: TemaTercihi): void {
  sayfaTercihi = tercih;
  try {
    if (tercih === 'system') localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, tercih);
  } catch {
    // Gizli sekmede localStorage yazılamayabilir — tema yine de uygulanır
  }
  uygula();
}

/**
 * Açılışta bir kez: `data-theme` hep yazılı olduğu için CSS'in `prefers-color-scheme` kuralı devreye
 * girmiyor. Cihaz koyuya geçince (Mac'te gün batımı) ya da başka sekmede seçim değişince bu sayfa
 * buradan uyuyor.
 */
export function temayiIzle(): void {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if (temaTercihi() === 'system') uygula();
  });
  window.addEventListener('storage', (e) => {
    if (e.key !== STORAGE_KEY && e.key !== null) return;
    sayfaTercihi = null;
    uygula();
  });
}

export function temaDinle(dinleyici: () => void): () => void {
  window.addEventListener(OLAY, dinleyici);
  return () => window.removeEventListener(OLAY, dinleyici);
}
